document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.js-p-accordionBtn').forEach((
        /** @type {HTMLElement} */ el,
    ) => {
        el.addEventListener(
            'click',
            (/** @type {Event} */ ev) => {
                if (ev.target.tagName === 'LABEL') {
                    return; // NOTE: ラベル上をクリックした場合にイベントが2回呼び出されるのを防止する
                }

                const elTrigger = ev.currentTarget;
                const elContent = elTrigger.closest('.js-p-accordion').
                    querySelector('.js-p-accordionTarget');

                let height = elContent.dataset.height;
                if (height === undefined) {
                    height = measureHeight(elContent); // px
                }

                if (elContent.classList.contains('active')) {
                    slideUp(elTrigger, elContent);

                    return;
                }

                slideDown(elTrigger, elContent, height);
            },
        );

        function measureHeight (/** @type {HTMLElement} */ el) {
            el.style.display = 'block';

            const height = window.getComputedStyle(el).height;

            el.dataset.height = height;
            el.style.display = 'hidden';

            el.querySelectorAll('.js-p-accordionTarget').forEach(
                (/** @type {HTMLElement} */ el) => {
                    el.style.display = 'hidden';
                },
            );

            return height;
        }

        function slideUp (
            /** @type {HTMLElement} */ elTrigger,
            /** @type {HTMLElement} */ elContent,
        ) {
            elTrigger.classList.remove('active');
            elContent.classList.remove('active');
            elContent.style.minHeight = '';
            const currentHeight = window.getComputedStyle(elContent).height;
            const anim = elContent.animate(
                [
                    { height: currentHeight, opacity: '0.7' },
                    { height: '0', opacity: '0' },
                ],
                { id: 'slideUp', duration: 500, fill: 'forwards', easing: 'ease-out' },
            );
            anim.addEventListener('finish', () => {
                elContent.style.display = 'hidden';
            });
        }

        function slideDown (
            /** @type {HTMLElement} */ elTrigger,
            /** @type {HTMLElement} */ elContent,
            /** @type {string} */ height,
        ) {
            elTrigger.classList.add('active');
            elContent.style.display = 'block';
            const anim = elContent.animate(
                [
                    { height: '0', opacity: '0' },
                    { height: height, opacity: '1' },
                ],
                { id: 'slideDown', duration: 500, fill: 'forwards', easing: 'ease-in-out' },
            );
            anim.addEventListener('finish', () => {
                elContent.classList.add('active');
                elContent.style.minHeight = height;
            });
        }
    });
});
